export default __webpack_public_path__ + "static/media/warning.2eb383a1.svg";